import React, { useState } from 'react';
import { AnimatedSection } from '../shared/AnimatedSection';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Qué es exactamente LOS 12?',
    answer: 'LOS 12 es una experiencia digital que explora los arquetipos zodiacales desde una perspectiva mitológica y simbólica. No es astrología predictiva ni tarot. Es un viaje interno hacia el patrón fundamental que define tu signo.'
  }, {
    question: '¿Es esto astrología tradicional?',
    answer: 'No. LOS 12 no trabaja con tránsitos, casas astrológicas ni predicciones. Se enfoca en el arquetipo puro de cada signo: su energía, patrones, sombras y naturaleza esencial.'
  }, {
    question: '¿Cómo recibo mi acceso?',
    answer: `Todas las experiencias son digitales y se activan instantáneamente después de tu compra.

Dependiendo de la experiencia seleccionada:

• Algunas versiones incluyen acceso directo por correo electrónico.
• Las experiencias inmersivas y accesos completos se desbloquean dentro del Portal de Usuario privado, donde podrás explorar tus Reinos y documentos de forma online.

Recibirás por correo las instrucciones y códigos necesarios para activar tu acceso.`
  }, {
    question: '¿Puedo solicitar un reembolso?',
    answer: 'Sí. Ofrecemos reembolsos completos dentro de los primeros 7 días si sientes que la experiencia no fue lo que esperabas. Consulta nuestra política de reembolsos para más detalles.'
  }, {
    question: '¿En qué idioma y formato están los archivos?',
    answer: 'Todo el contenido está en español. Los archivos incluyen PDFs de alta calidad, experiencias visuales interactivas y, en algunos casos, contenido multimedia (audio/video) según el producto.'
  }, {
    question: '¿Para quién NO es esto?',
    answer: 'No es para ti si buscas predicciones del futuro, consejos diarios, compatibilidad romántica rápida o astrología tradicional con tránsitos. LOS 12 es para quienes buscan introspección profunda y trabajo simbólico.'
  }];
  return <section className="py-20 px-6 bg-cosmic-black" data-id="element-200">
      <div className="container mx-auto max-w-3xl" data-id="element-201">
        <AnimatedSection data-id="element-202">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-center text-white mb-16" data-id="element-203">
            Preguntas Frecuentes
          </h2>
        </AnimatedSection>

        <div className="space-y-4" data-id="element-204">
          {faqs.map((faq, index) => <AnimatedSection key={index} delay={index * 0.1} data-id="element-205">
              <div className="bg-cosmic-darker border border-gold-primary border-opacity-20 rounded-lg overflow-hidden" style={{
            boxShadow: '0 0 10px rgba(201, 168, 76, 0.1)'
          }} data-id="element-206">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex justify-between items-center text-left hover:bg-cosmic-dark transition-colors" data-id="element-207">
                  <span className="text-white font-medium pr-4" data-id="element-208">
                    {faq.question}
                  </span>
                  <motion.div animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.3
              }} data-id="element-209">
                    <ChevronDownIcon size={24} className="text-gold-primary flex-shrink-0" data-id="element-210" />
                  </motion.div>
                </button>

                <AnimatePresence data-id="element-211">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-212">
                      <div className="px-6 pb-5 text-gray-300 leading-relaxed whitespace-pre-line" data-id="element-213">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </AnimatedSection>)}
        </div>
      </div>
    </section>;
}